<template>
    <button
        class="menu-item"
        :class="{'is-active': props.item.isActive ? props.item.isActive() : null}"
        :title="props.item.title"
        @click="props.item.action"
    >
        <i class="menu-item__icon" :class="`ri-${props.item.icon}`" />
    </button>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import 'remixicon/fonts/remixicon.css';
    import type {Item} from '../Item';

    const props = defineProps<{
        item: Item;
    }>();

    computed(() => {
        return {
            isActive: props.item.isActive ? props.item.isActive() : null,
        };
    });
</script>

<style lang="scss" scoped>
    .menu-item {
        background: transparent;
        border: none;
        border-radius: var(--joy-core-radius-3);
        color: var(--joy-color-text-default);
        cursor: pointer;
        height: 2.25rem;
        padding: 0.25rem;
        margin-right: 0.25rem;
        width: 1.75rem;

        &__icon {
            display: block;
            font-size: var(--joy-font-size-primary-600);
            line-height: 1;
        }

        &.is-active,
        &:hover {
            background-color: var(--joy-color-information-10);
        }
    }
</style>
